import { render, staticRenderFns } from "./confirm-password.vue?vue&type=template&id=37ff0a4d"
import script from "./confirm-password.vue?vue&type=script&lang=ts"
export * from "./confirm-password.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports